module.exports = __webpack_public_path__ + "img/trash-blue-icon.0ff2fb81.svg";